import { HTTP_NO_CONTENT_FOUND } from '../../common/constants/CommonConstants';
import {
  fetchOrganizationPortfolioSummary,
  fetchAccountPortfolioSummary,
  fetchOrganizationRenewalsSummary,
  fetchAccountRenewalsSummary,
  fetchCockpitSuccessPlans,
  fetchCockpitTasks,
  fetchCockpitPlaybooks,
  createActionItemProcessRequest,
  fetchActionItems,
  updateActionItemActivity,
} from '../routines/cockpitRoutines';

const initialState = {
  organizationData: null,
  accountData: null,
  organizationRenewalData: null,
  accountRenewalData: null,
  successPlans: null,
  tasksData: null,
  playbookData: null,
  actionItems: {},
  isCockpitPortfolioLoading: false,
  isCockpitRenewalsLoading: false,
  isSuccessPlansLoading: false,
  isCockpitTasksLoading: false,
  isCockpitPlaybooksLoading: false,
  isActionItemLoading: false,
  error: null,
  period: null,
  context: null,
  account: null,
  organization: null,
  actionItemStatusCode: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case fetchOrganizationPortfolioSummary.TRIGGER:
    case fetchAccountPortfolioSummary.TRIGGER: {
      return {
        ...state,
        isCockpitPortfolioLoading: true,
        error: null,
      };
    }
    case fetchOrganizationRenewalsSummary.TRIGGER:
    case fetchAccountRenewalsSummary.TRIGGER: {
      return {
        ...state,
        isCockpitRenewalsLoading: true,
        error: null,
      };
    }
    case fetchCockpitSuccessPlans.TRIGGER: {
      return {
        ...state,
        isSuccessPlansLoading: true,
        error: null,
      };
    }
    case fetchCockpitTasks.TRIGGER: {
      return {
        ...state,
        isCockpitTasksLoading: true,
        error: null,
      };
    }
    case fetchCockpitPlaybooks.TRIGGER: {
      return {
        ...state,
        isCockpitPlaybooksLoading: true,
        error: null,
      };
    }
    case updateActionItemActivity.TRIGGER: {
      return {
        ...state,
        isActionItemLoading: true,
        error: null,
      };
    }
    case fetchActionItems.TRIGGER: {
      return {
        ...state,
        isActionItemLoading: true,
        error: null,
        actionItemStatusCode: null,
        actionItems: null,
        period: null,
        context: null,
        account: null,
        organization: null,
      };
    }
    case fetchOrganizationPortfolioSummary.SUCCESS: {
      return {
        ...state,
        isCockpitPortfolioLoading: false,
        error: null,
        organizationData: action.payload,
      };
    }
    case fetchAccountPortfolioSummary.SUCCESS: {
      return {
        ...state,
        isCockpitPortfolioLoading: false,
        error: null,
        accountData: action.payload,
      };
    }
    case fetchOrganizationRenewalsSummary.SUCCESS: {
      return {
        ...state,
        isCockpitRenewalsLoading: false,
        error: null,
        organizationRenewalData: action.payload,
      };
    }
    case fetchAccountRenewalsSummary.SUCCESS: {
      return {
        ...state,
        isCockpitRenewalsLoading: false,
        error: null,
        accountRenewalData: action.payload,
      };
    }
    case fetchCockpitSuccessPlans.SUCCESS: {
      return {
        ...state,
        isSuccessPlansLoading: false,
        error: null,
        successPlans: action.payload,
      };
    }
    case fetchCockpitTasks.SUCCESS: {
      return {
        ...state,
        isCockpitTasksLoading: false,
        error: null,
        tasksData: action.payload,
      };
    }
    case fetchCockpitPlaybooks.SUCCESS: {
      return {
        ...state,
        isCockpitPlaybooksLoading: false,
        error: null,
        playbookData: action.payload,
      };
    }
    case createActionItemProcessRequest.SUCCESS: {
      return {
        ...state,
        isActionItemLoading: false,
        error: null,
      };
    }
    case updateActionItemActivity.SUCCESS: {
      const currentActionItems = {
        ...state.actionItems,
        actionItemData: state.actionItems.actionItemData.map((item) => ({
          ...item,
          actionItems: item.actionItems.map((actionItem) =>
            actionItem.actionItemId === action.payload.actionItemId
              ? {
                  ...actionItem,
                  activityId: action.payload.activityId,
                  activityType: action.payload.activityType,
                }
              : actionItem
          ),
        })),
      };

      return {
        ...state,
        isActionItemLoading: false,
        error: null,
        actionItems: currentActionItems,
      };
    }
    case fetchActionItems.SUCCESS: {
      if (action?.payload === HTTP_NO_CONTENT_FOUND) {
        return {
          ...state,
          isActionItemLoading: false,
          error: null,
          actionItemStatusCode: action.payload,
        };
      }
      const { period, context, account, organization } = action.payload;
      return {
        ...state,
        isActionItemLoading: false,
        actionItemStatusCode: null,
        error: null,
        actionItems: action.payload,
        period,
        context,
        account,
        organization,
      };
    }
    case fetchOrganizationPortfolioSummary.FAILURE:
    case fetchAccountPortfolioSummary.FAILURE: {
      return {
        ...state,
        isCockpitPortfolioLoading: false,
        error: action.payload.error,
      };
    }
    case fetchOrganizationRenewalsSummary.FAILURE:
    case fetchAccountRenewalsSummary.FAILURE: {
      return {
        ...state,
        isCockpitRenewalsLoading: false,
        error: action.payload.error,
      };
    }
    case fetchCockpitSuccessPlans.FAILURE: {
      return {
        ...state,
        isSuccessPlansLoading: false,
        error: action.payload.error,
      };
    }
    case fetchCockpitTasks.FAILURE: {
      return {
        ...state,
        isCockpitTasksLoading: false,
        error: action.payload.error,
      };
    }
    case fetchCockpitPlaybooks.FAILURE: {
      return {
        ...state,
        isCockpitPlaybooksLoading: false,
        error: action.payload.error,
      };
    }
    case fetchActionItems.FAILURE:
    case updateActionItemActivity.FAILURE:
    case createActionItemProcessRequest.FAILURE: {
      return {
        ...state,
        isActionItemLoading: false,
        error: action.payload.error,
      };
    }
    default:
      return state;
  }
};
